import Vue from "vue";
import { SET_LOADING, SET_USER } from "../../store/modules/authUserModule";
import { SET_ONBOARDING_DATA } from "../../store/modules/vueOnboardingModule";
import store from "../../store/store";
import jwtToken from "../helpers/jwtToken";
import ratingService from '../services/ratingService';
import {OPEN_POLICY} from "../../store/modules/policyModule";

class AuthService {
    /**
     * @description Get information account of current user logged in
     * @returns Promise
     */
    async getUser() {
      store.dispatch('authUser/' + SET_LOADING, true);
        try {

            const res = await Vue.axios.get("/auth/user");
            const { data } = res.data;

            // Store data user
            store.dispatch('authUser/' + SET_USER, data);
            store.dispatch('authUser/' + SET_LOADING, false);
            if (data.hasOwnProperty('onboarding')) {
                const onboarding = data.onboarding;

                store.dispatch(SET_ONBOARDING_DATA, {
                    flow: onboarding.flow,
                    tutorials: onboarding.tutorials || {},
                    status: onboarding.status,
                })
            }

            // Save user rating
            if (data.hasOwnProperty('rating_expired_at') && data.rating_expired_at) {
                ratingService.setDisplayedExpires("date", data.rating_expired_at);
            }
            else {
                ratingService.removeDisplayedExpires("date", data.rating_expired_at);
            }

            if (data.rating_close_times || false) {
                ratingService.setCloseTimes(data.rating_close_times);
            }
            else {
                ratingService.removeCloseTimes();
            }
            // policy status
            if (data.hasOwnProperty('policy') && data.policy) {
                store.dispatch(OPEN_POLICY, false)
            } else {
                store.dispatch(OPEN_POLICY, true)
            }

            return data;
        } catch (e) {
            // If has error, unloading
            store.dispatch('authUser/' + SET_LOADING, false);

            return Promise.reject(e);
        }
    }

    /**
     * @description To send a request for refresh the token
     * was expired at before that
     *
     * @returns Promise
     */
    async refreshToken() {
        try {
            const response = await Vue.axios.get("/auth/refresh");
            const { access_token, expired_in } = response.data.data;

            // Set new token in service
            if (jwtToken.isRememberToken()) {
                jwtToken.setToken(access_token, jwtToken.getExpires("forever"));
            }
            else {
                jwtToken.setToken(access_token, jwtToken.getExpires("limit"));
            }

            return { access_token, expired_in };
        } catch (e) {
            const { response } = e;

            // Conflict refresh token, to remove it
            if (response.status === 409) {
                jwtToken.removeToken();
            }

            return Promise.reject(e);
        }
    }

    /**
     * @description To send request require recover password
     * @param {{email}} data
     * @returns Promise
     */
    async recoverPassword(data = {}) {
        try {
            return await Vue.axios.post("/auth/recover-password", data);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    async checkRecoverPasswordCode(recoverCode = "", params = {}) {
        try {
            const response = await Vue.axios({
                method: "GET",
                url: `/auth/check-recover-password-code/${recoverCode}`,
                params,
            });

            return response;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    async resetPassword({ data }) {
        try {
            const response = await Vue.axios({
                url: "/auth/reset-password",
                method: "POST",
                data: data,
            });

            return response;
        } catch (e) {
            return Promise.reject(e);
        }
    }

    async register(data = null, params = {}) {
        if (!data)
            return Promise.reject({
                message: "Không có dữ liệu để gửi",
            });

        try {
            const response = await Vue.axios({
                method: "POST",
                url: "/auth/register",
                data: data,
            });
            return response;
        } catch (e) {
            return Promise.reject(e);
        }
    }
    async goCheck(data = null, params = {}) {
      if (!data)
          return Promise.reject({
              message: "Không có dữ liệu để gửi",
          });

      try {
          const response = await Vue.axios({
              method: "POST",
              url: "/auth/beforegister",
              data: data,
          });

          return response;
      } catch (e) {
          return Promise.reject(e);
      }
  }
    /**
     *
     * @param {{ emailOrUsername: string, password: string }} data
     * @returns
     */
    async login(data) {
        try {
            return await Vue.axios.post("/auth/login", data);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description To send a request verify email for publisher
     * @param {{email}} data
     * @returns Promise
     */
    async requestVerifyEmail(data = {}) {
        try {
            return await Vue.axios.post("/auth/verify-email", data)
        } catch (e) {
            return Promise.reject(e);
        }
    }

    /**
     * @description To verify email for the user
     * @param {String} token
     * @returns
     */
    async toVerifyEmail(token = "") {
        try {
            return await Vue.axios.post(`/auth/verify-email/${token}`);
        } catch (e) {
            return Promise.reject(e);
        }
    }

    async getSlideImagesVideos() {
        try {
            let response = await Vue.axios.get("/auth/get-slide-images-videos");
            let { data } = response.data;
            return data;
        } catch (e) {
            return Promise.reject(e);
        }
    }
}

const authService = new AuthService();

export default authService;



// WEBPACK FOOTER //
// ./src/core/services/authService.js